import { ADD_CUSTOMER, UPDATE_CUSTOMER, GET_CUSTOMER, GET_ONE_CUSTOMER } from '../types';

const initialState = { list: [], single: null };

const reducer = (state = initialState, action) => {
   const { type, payload } = action;

   switch (type) {
      case GET_CUSTOMER:
         return { ...state, list: payload };

      case UPDATE_CUSTOMER:
         return {
            ...state,
            list: state.list.map((item) => (item.id === payload.id ? payload : item)),
         };

      case ADD_CUSTOMER:
         return {
            ...state,
            list: [payload, ...state.list],
         };

      case GET_ONE_CUSTOMER:
         return { ...state, single: payload || initialState.single };

      default:
         return state;
   }
};

export default reducer;
